import axios from 'axios';
import AbstractDataService from './abstract.data.service';
import { settingFiles } from './settings.const';

/*
function blobToBase64(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
            // var base64 = reader.result.split(',')[1];
            resolve(reader.result);
        };
        // reader.readAsDataURL(blob);
        reader.readAsBinaryString(blob);
    });
}
*/

function init(name) {
    const gdrive = window.gapi.client.drive.files;

    return gdrive.list({
        q: `name = '${name}' and mimeType = 'application/vnd.google-apps.folder' and trashed = false`
    }).then(function (response) {
        if (!response.result.files.length) {
            return gdrive.create({
                resource: {
                    name: name,
                    mimeType: 'application/vnd.google-apps.folder'
                }
            }).then(function (response) {
                return response.result;
            });
        } else {
            return response.result.files[0];
        }
    });
}

function files(folder, query, params) {
    const gdrive = window.gapi.client.drive.files;

    let requestParams = Object.assign({
        q: `mimeType = 'application/json' and trashed = false${query}`,
        parents: [folder.id]
    }, params);

    return gdrive.list(requestParams).then(function (response) {
        if (response.result.nextPageToken) {
            return files(folder, query, { pageToken: response.result.nextPageToken }).then(function (nextFiles) {
                return [...response.result.files, ...nextFiles];
            });
        } else {
            return response.result.files;
        }
    });
}

async function settings(folder) {
    let query = settingFiles.map(item => `name = '${item}'`).join(' or ');
    return files(folder, `and (${query})`);
}

async function wishlist(folder) {
    let query = `name = 'wishlist.json'`;
    return files(folder, `and (${query})`);
}

function wallets(folder) {
    let query = settingFiles.map(item => `name != '${item}'`).join(' and ');
    query += ` and name!='wishlist.json'`;
    return files(folder, ` and ${query}`);
}

function insert(folder, file) {
    const metadata = {
        name: file.name,
        mimeType: file.mimeType,
        parents: [folder.id],
    };

    const body = new Blob([JSON.stringify(file.data, null, 4)], { type: file.mimeType });

    const form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    form.append('file', body);

    const accessToken = window.gapi.auth.getToken().access_token;
    const config = {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    };

    const url = 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id';

    return axios.post(url, form, config)
        .then(function (result) {
            return result.data;
        });
}

function update(file) {
    const body = new Blob([JSON.stringify(file.data, null, 4)], { type: file.mimeType });

    const accessToken = window.gapi.auth.getToken().access_token;
    const config = {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    };

    const url = `https://www.googleapis.com/upload/drive/v3/files/${file.id}?uploadType=media`;

    return axios.patch(url, body, config)
        .then(function (result) {
            return result.data;
        });
}

function save(folder, file) {
    if (file.id) {
        return update(file);
    } else {
        return insert(folder, file);
    }
}

function remove(file) {
    const gdrive = window.gapi.client.drive.files;

    return new Promise((resolve) => {
        gdrive.delete({
            'fileId': file.id
        }).execute(resolve);
    });
}

function load(file) {
    const gdrive = window.gapi.client.drive.files;

    return gdrive.get({
        fileId: file.id,
        // fields: 'webContentLink'
        // 'mimeType' : 'application/json',
        alt: 'media'
    }).then(function (response) {
        // var webContentLink = success.result.webContentLink; //the link is in the success.result object
        return JSON.parse(response.body);
    });
}

class GDriveDataService extends AbstractDataService {
    settingsId = {};

    constructor(appName, googleUser, onReady) {
        super();

        this.appName = appName;
        this.googleUser = googleUser;

        init(appName).then(async (folder) => {
            this.appFolder = folder;
            this.init().then(() => {
                onReady && onReady();
            });
        });
    }

    refreshWallets() {
        return wallets(this.appFolder).then((files) => {
            this.wallets = files.map((file) => {
                let name = file.name.split('.')[0];
                let [year, month] = name.split('-').map(item => parseInt(item));

                let wallet = {
                    year,
                    month,
                    id: file.id
                }

                this.walletWrappering(wallet);

                return wallet;
            });
        });
    }

    loadSettings() {
        return settings(this.appFolder).then(async (files) => {
            let result = {}

            for (let file of files) {
                let name = file.name.split('.')[0];
                this.settingsId[name] = file.id;
                result[name] = await load(file);
            }

            return result;
        });
    }

    async saveSetting() {
        for (let item of settingFiles) {
            let name = item.split('.')[0];

            let file = {
                name: item,
                mimeType: 'application/json',
                data: this.settings[name],
                id: this.settingsId[name]
            }

            await save(this.appFolder, file)
                .then((result) => {
                    this.settingsId[name] = result.id;
                    return result;
                });
        }
    }

    loadWishlist() {
        return wishlist(this.appFolder)
            .then(async ([file]) => {
                this.wishlistId = file && file.id;
                return await load(file);
            });
    }

    async saveWishlist() {
        let file = {
            name: `wishlist.json`,
            mimeType: 'application/json',
            data: this.wishlist,
            id: this.wishlistId
        }

        return save(this.appFolder, file)
            .then((result) => {
                this.wishlistId = result.id;
                return this;
            });
    }

    walletMethods() {
        let app = this;

        return {
            save() {
                let file = {
                    name: `${this.year}-${this.month.toString().padStart(2, '0')}.json`,
                    mimeType: 'application/json',
                    data: this.data,
                    id: this.id
                }

                return save(app.appFolder, file)
                    .then((result) => {
                        this.id = result.id;
                        return this;
                    });
            },
            remove() {
                let { year, month, id } = this;

                return (() => {
                    if (id) {
                        return remove({ year, month, id });
                    } else {
                        return Promise.resolve();
                    }
                })().then(() => {
                    return app.removeWallet(this);
                });
            },
            reset() {
                let { year, month, id } = this;

                return (() => {
                    if (id) {
                        return load({ year, month, id });
                    } else {
                        return Promise.resolve({});
                    }
                })().then((data) => {
                    this.data = data;
                    return data;
                });
            }
        }
    }

    async getWallet(year, month) {
        let wallet = await super.getWallet(year, month);

        if (!wallet) {
            return Promise.reject("Wallet is not exist");
        }

        if (!wallet.data) {
            return load({ year, month, id: wallet.id }).then((data) => {
                wallet.data = data;
                return wallet;
            });
        } else {
            return Promise.resolve(wallet);
        }
    }

    async import(data) {
        if (!data) {
            return false;
        }

        let x = 0;

        for (let item of data) {
            console.log(item.year + ' - ' + item.month);

            let wallet = {
                year: item.year,
                month: item.month,
                data: {
                    salaries: item.salaries,
                    expenses: item.expenses
                }
            };

            this.walletWrappering(wallet);

            await wallet.save().then((result) => {
                x++;
                return result;
            });
        }

        alert(x);

        return true;
    }
}

export default GDriveDataService;